import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { CreateSecretParams, Secret, SecretMutationParams, SecretParams } from '@/types/secrets';
import ajax from '@/utils/ajax';

export const secretRepository = {
  async getSecret({
    host,
    decrypt,
    params
  }: {
    host: string;
    decrypt: boolean;
    params: SecretParams;
  }): Promise<Secret> {
    const { entity_type_app_label, entity_type, entity_id, secret_type_slug } = params;
    const pathPrefix = decrypt ? `/api/dugout/vault/secrets/decrypt` : `/api/dugout/vault/secrets`;
    const path = `${pathPrefix}/${entity_type_app_label}/${entity_type}/${entity_id}/${secret_type_slug}/`;
    const response = await ajax.get({
      url: `${host}${path}`
    });

    return response.data;
  },

  async createSecret({
    host,
    params
  }: {
    host: string;
    params: CreateSecretParams;
  }): Promise<Secret> {
    const { entity_type, entity_id, secret_type_slug, value } = params;
    const path = '/api/dugout/vault/secrets/';
    const response = await ajax.post<CreateSecretParams, AxiosResponse<Secret>>({
      url: `${host}${path}`,
      data: {
        entity_id,
        entity_type,
        secret_type_slug,
        value
      }
    });

    return response.data;
  },

  async updateSecret({
    host,
    params
  }: {
    host: string;
    params: SecretMutationParams;
  }): Promise<Secret> {
    const { entity_type_app_label, entity_type, entity_id, secret_type_slug } = params;
    const path = `/api/dugout/vault/secrets/${entity_type_app_label}/${entity_type.includes('.') ? entity_type.split('.')[1] : entity_type}/${entity_id}/${secret_type_slug}/`;
    const response = await ajax.patch<SecretMutationParams, AxiosResponse<Secret>>({
      url: `${host}${path}`,
      data: params
    });

    return response.data;
  }
};

const SecretRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getSecret({
      decrypt,
      params
    }: {
      decrypt: boolean;
      params: SecretParams;
    }): Promise<Secret> {
      return secretRepository.getSecret({ host, decrypt, params });
    },

    async createSecret(params: CreateSecretParams): Promise<Secret> {
      return secretRepository.createSecret({ host, params });
    },

    async updateSecret(params: SecretMutationParams): Promise<Secret> {
      return secretRepository.updateSecret({ host, params });
    }
  };
};

export default SecretRepository;
